import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { GetEnumValuesDto, SmartSmsStatisticsDailyDeliveryCountResult, StatisticsSendStatus } from 'src/app/core/api/models';
import { SendStatusTypesUi } from 'src/app/configs/status-type-ui.config';

@Component({
    selector: 'app-bar-chart-send-details-stats',
    templateUrl: './bar-chart-send-details-stats.component.html',
    standalone: false
})
export class BarChartSendDetailsStatsComponent implements OnInit {

  @Input() model: SmartSmsStatisticsDailyDeliveryCountResult[] = [];
  @Input() chartId: string;
  @Input() StatisticsSendStatusEnumValues: GetEnumValuesDto[];
  @Input() PersianMonthEnumValues: GetEnumValuesDto[];
  @Input() dateType: string = "";

  labels: string[] = [];
  dataset: any[] = [];
  title: string = this.translateService.instant('pages.statisticalReports.sendingStatusBarChart');
  get StatisticsSendStatus() { return StatisticsSendStatus };

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes["model"] || changes["StatisticsSendStatusEnumValues"]) {
      if (this.model?.length && this.StatisticsSendStatusEnumValues?.length) {
        this.setData();
      }
    }
  }

  setData() {

    const statisticsSendStatus_types = Object.keys(StatisticsSendStatus).filter((v) => isNaN(Number(v)));

    function statisticsSendStatus_getKeyByValue(value: string) {
      const indexOfS = Object.values(StatisticsSendStatus).indexOf(value as unknown as StatisticsSendStatus);
      const key = Object.keys(StatisticsSendStatus)[indexOfS];
      return key;
    }

    let statisticsSendStatus_data = [];
    statisticsSendStatus_types.forEach(item => {
      statisticsSendStatus_data.push({
        label: this.StatisticsSendStatusEnumValues.find(a => a.key.toString() == statisticsSendStatus_getKeyByValue(item))?.value,//this.translateService.instant('enums.DeliveryStatus.' + item),
        data: [],
        backgroundColor: SendStatusTypesUi.find(a => a.type == +statisticsSendStatus_getKeyByValue(item))?.color
      });
    });

    this.model.forEach((item) => {
      if (this.dateType == "daily")
        this.labels.push(item.persianDay.toString());
      else
        this.labels.push(this.PersianMonthEnumValues.find(a => a.key == item.persianMonth)?.value);

      statisticsSendStatus_types.forEach((type, index) => {
        if (item.items.find(a => a.statisticsSendStatus.toString() == statisticsSendStatus_getKeyByValue(type)))
          statisticsSendStatus_data[index].data.push(item.items.find(a => a.statisticsSendStatus.toString() == statisticsSendStatus_getKeyByValue(type))?.partsCount);
        else
          statisticsSendStatus_data[index].data.push(0);
      });
    });
    this.dataset = statisticsSendStatus_data.filter(a => a.data.length > 0 && a.data.some(b => b != 0));
  }
}
